import React, { useEffect, useMemo, useRef } from 'react'
import { css } from '@emotion/css'
import IPButton from '../../../components/IPButton'
import { useCustomReducer } from '../../../base/customHooks'
import IPImage from '../../../components/IPImage'
import { IBank, ICreditCardCommissionRates, IGetBankInstallmentsResponse, IInstallments, IParampos, IParamposList } from '../models/models'
import { GetBankInstallmentsApi } from '../services/getBankInstallmentsApi'
import data from '../../../api/creditCardCommissionRates.json'
import { GetCompaniesApi } from '../../MySpecial/CurrentAccount/Extract/services/getCompaniesApi'
import { ICompany } from '../../ProductList/models/commonModels'
import IPSelectBox from '../../../components/IPSelectBox'
import { ISelectOption } from '../../../components/IPSelectBox/IPSelectBox'
import { financialButtonStyles } from '../FinancialInformationLayout'
import { exportToXLSX } from '../../../base/utils/dataHelper'
import Swal from 'sweetalert2'
import { GetBankListApi } from '../services/getBankList'
import { ListParamPosInsatallmentApi } from '../services/listParamPosInsatallmentApi'
import { ListParatikaPosInsatallmentApi } from '../services/listParatikaPosInsatallmentApi'
import { ListAkOdePosInsatallmentApi } from '../services/listAkOdePosInsatallmentApi'
import { IPosData } from '../../Admin/BankAndInstallementOperation/PosCompany/models/models'
import Table from '../../../components/Table'
import { BaseComponentWithContextProps, componentWithContext } from '../../../base/customHooks/componentHOC'
import { ListPosDataApi } from '../services/listPosDataApi'

enum operationType {
  Cart = 1,
  Payments = 2,
  Compare = 3,
}

const compareTypeTabs = [
  { label: 'Cari Ödeme', value: '3' },
  { label: 'Fırsat POS', value: '1' },
  { label: 'Avantaj POS', value: '0' },
  { label: 'FÇV', value: '2' },
]

const providerLogos: Record<string, string> = {
  'AkÖde': '/images/creditCard/aköde.svg',
  Paratika: '/images/creditCard/paratika.png',
  ParamPos: '/images/creditCard/param.png',
}

const bankNameComparator = (a: string, b: string) => {
  if (a === 'Diğer Bankalar' && b !== 'Diğer Bankalar') return 1
  if (a !== 'Diğer Bankalar' && b === 'Diğer Bankalar') return -1
  return a.localeCompare(b)
}

const compareTableScrollStyles = css`
  overflow-x: auto;
  scrollbar-width: auto;

  &::-webkit-scrollbar {
    height: 16px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #b5b5b5;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #7a7a7a;
  }
`

// table-bordered kullanır border-collapse: collapse, bu da position: sticky ile
// çakışıp sabit sütunun bir sonraki sütunün üzerine binmesine (yarım görünmesine) yol açar.
// separate + kendi border'ımızı vererek bunu düzeltiyoruz.
const compareTableStyles = css`
  border-collapse: separate;
  border-spacing: 0;

  th,
  td {
    border: 1px solid #dee2e6;
  }
`

const STICKY_COLUMN_WIDTH = 90

const stickyColumnHeaderStyle: React.CSSProperties = {
  textAlign: 'center',
  position: 'sticky',
  left: 0,
  zIndex: 3,
  width: `${STICKY_COLUMN_WIDTH}px`,
  backgroundColor: '#f8f9fa',
  boxShadow: '2px 0 4px -2px rgba(0, 0, 0, 0.2)',
}

const stickyColumnCellStyle: React.CSSProperties = {
  position: 'sticky',
  left: 0,
  zIndex: 1,
  width: `${STICKY_COLUMN_WIDTH}px`,
  backgroundColor: '#fff',
  boxShadow: '2px 0 4px -2px rgba(0, 0, 0, 0.2)',
}

type ICompareInstallment = IInstallments & { ProviderLabel?: string }

interface ICompareColumn {
  key: string
  bankId: string
  bankName: string
  providerLabel?: string
}

interface ICompareCell {
  key: string
  rate?: number
  isBest: boolean
}

interface ICompareRow {
  installment: number
  label: string
  cells: ICompareCell[]
}

interface ICreditCardComissionRatesState {
  operation: number
  bankInstallmentsData?: IGetBankInstallmentsResponse
  creditCardCommissionRates: ICreditCardCommissionRates[]
  companies: ICompany[]
  companyOption?: ISelectOption
  typeOption?: ISelectOption
  installment: IInstallments[]
  paramInstallment: IInstallments[]
  paratikaInstallment: IInstallments[]
  akodeInstallment: IInstallments[]
  banks: ISelectOption[]
  paramBanks: ISelectOption[]
  paratikaBanks: ISelectOption[]
  akodeBanks: ISelectOption[]
  bankOption?: ISelectOption
  campaigns: ISelectOption[]
  campaignsOption?: ISelectOption
  paramposBool: boolean
  selectedPosType?: string
  posDataList: IPosData[]
  compareTypeOption: string
  compareCompanyOption?: ICompany
  compareCampaignOption?: ISelectOption
  compareFlashButton?: string
  compareOnlyBestColumns: boolean
  compareAlwaysShowGroup: boolean
}

function CreditCardComissionRates2(props: BaseComponentWithContextProps) {
  const getInitialState = (): ICreditCardComissionRatesState => {
    return {
      operation: operationType.Payments,
      creditCardCommissionRates: data.bank,
      companies: [],
      installment: [],
      paramInstallment: [],
      paratikaInstallment: [],
      akodeInstallment: [],
      paramBanks: [],
      paratikaBanks: [],
      akodeBanks: [],
      banks: [],
      campaigns: [],
      paramposBool: false,
      posDataList: [],
      compareTypeOption: '3',
      compareOnlyBestColumns: false,
      compareAlwaysShowGroup: false,
    }
  }

  const types = [
    { label: 'Avantaj POS', value: '0' },
    { label: 'Fırsat POS', value: '1' },
    { label: 'FÇV', value: '2' },
    { label: 'Cari Ödeme', value: '3' },
    { label: 'Cari Ödeme Param POS', value: '4' },
    { label: 'Cari Odeme Paratika', value: '5' },
    { label: 'Cari Odeme AkÖde', value: '6' },
  ]

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<ICreditCardComissionRatesState>(intialState)

  useEffect(() => {
    getCompanies()
    getParamBanks()
    getParatikaBanks()
    getAkOdeBanks()
    getBankInstallments()
    getParamInstallments()
    getParatikaInstallments()
    getAkOdeInstallments()
    getPosData()
  }, [])

  const normalizeText = (value?: string) =>
    (value || '')
      .toLocaleUpperCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')

  const getPosData = async () => {
    const response = await new ListPosDataApi({}).listPosData()
    setState({ posDataList: response || [] })
  }

  useEffect(() => {
    selectCampaign()
    setBank("0")
  }, [state.bankInstallmentsData])

  const getBankInstallments = async () => {
    props.showLoading()
    const bankInstallments: GetBankInstallmentsApi = new GetBankInstallmentsApi({})
    bankInstallments.getBankInstallments().then((res: IGetBankInstallmentsResponse) => {
      if (res) {
        props.hideLoading()
        const data: IInstallments[] = []
        res.PaymentInstallments.map(payment => {
          payment.Installments.map(ins => {
            return data.push({
              BankId: ins.BankId,
              BankName: ins.BankName,
              Id: ins.Id,
              Installment: ins.Installment,
              InterestRate: ins.InterestRate,
              PaymentTermsId: ins.PaymentTermsId,
              PaymentTermsName: ins.PaymentTermsName,
              Type: ins.Type,
              Company: payment.Company,
              AdditionalInstallment: ins.AdditionalInstallment,
            })
          })
        })

        let myData = (data as any).sort((a, b) => {
          // Önce Company'ye göre sıralama
          const companyComparison = a.Company - b.Company;
          if (companyComparison !== 0) {
            return companyComparison;
          }

          // Sonra Type'a göre sıralama
          const typeComparison = b.Type - a.Type;
          if (typeComparison !== 0) {
            return typeComparison;
          }

          // Ardından BankName'e göre sıralama
          if (a.BankName === "Diğer Bankalar" && b.BankName !== "Diğer Bankalar") {
            return 1; // "Diğer Bankalar" en sonda olsun
          } else if (a.BankName !== "Diğer Bankalar" && b.BankName === "Diğer Bankalar") {
            return -1; // "Diğer Bankalar" en sonda olsun
          } else {
            // "Diğer Bankalar" değilse, alfabetik sıralamaya devam et
            const bankNameComparison = a.BankName.localeCompare(b.BankName);
            if (bankNameComparison !== 0) {
              return bankNameComparison;
            }
          }

          // En son Installment'a göre numerik sıralama
          return a.Installment - b.Installment;
        })
        setState({ bankInstallmentsData: res, installment: myData })
      }
    })
  }

  const getParamInstallments = async () => {
    const data: IInstallments[] = []
    const listParamPosInsatallmentApi: ListParamPosInsatallmentApi = new ListParamPosInsatallmentApi({})
    listParamPosInsatallmentApi.listParamPosInsatallmentNoBank().then((res: IParamposList[]) => {
      if (res) {
        res.map((ins) => {
          return data.push({
            ...ins,
            BankId: String(ins.BankId),
            PaymentTermsId: 0,
            PaymentTermsName: '',
            Type: '4',
            Company: ins.Company,
            AdditionalInstallment: ''
          })
        })

        let mydata = (data as any).sort((a, b) => {
          // Önce Company'ye göre sıralama
          const companyComparison = a.Company - b.Company;
          if (companyComparison !== 0) {
            return companyComparison;
          }

          // Sonra Type'a göre sıralama
          const typeComparison = b.Type - a.Type;
          if (typeComparison !== 0) {
            return typeComparison;
          }

          // Ardından BankName'e göre sıralama
          if (a.BankName === "Diğer Bankalar" && b.BankName !== "Diğer Bankalar") {
            return 1; // "Diğer Bankalar" en sonda olsun
          } else if (a.BankName !== "Diğer Bankalar" && b.BankName === "Diğer Bankalar") {
            return -1; // "Diğer Bankalar" en sonda olsun
          } else {
            // "Diğer Bankalar" değilse, alfabetik sıralamaya devam et
            const bankNameComparison = a.BankName.localeCompare(b.BankName);
            if (bankNameComparison !== 0) {
              return bankNameComparison;
            }
          }

          // En son Installment'a göre numerik sıralama
          return a.Installment - b.Installment;
        })
        return setState({ paramInstallment: mydata })
      }
    })
  }


  const getParatikaInstallments = async () => {
    const data: IInstallments[] = []
    const api: ListParatikaPosInsatallmentApi = new ListParatikaPosInsatallmentApi({})
    api.listParatikaPosInsatallmentNoBank().then((res: IParamposList[]) => {
      if (res) {
        res.map((ins) => {
          return data.push({
            ...ins,
            BankId: String(ins.BankId),
            PaymentTermsId: 0,
            PaymentTermsName: '',
            Type: '5',
            Company: ins.Company,
            AdditionalInstallment: ''
          })
        })
        const mydata = (data as any).sort((a, b) => a.Company - b.Company || b.Type - a.Type || a.BankName.localeCompare(b.BankName) || a.Installment - b.Installment)
        return setState({ paratikaInstallment: mydata })
      }
    })
  }

  const getAkOdeInstallments = async () => {
    const data: IInstallments[] = []
    const api: ListAkOdePosInsatallmentApi = new ListAkOdePosInsatallmentApi({})
    api.listAkOdePosInsatallmentNoBank().then((res: IParamposList[]) => {
      if (res) {
        res.map((ins) => {
          return data.push({
            ...ins,
            BankId: String(ins.BankId),
            PaymentTermsId: 0,
            PaymentTermsName: '',
            Type: '6',
            Company: ins.Company,
            AdditionalInstallment: ''
          })
        })
        const mydata = (data as any).sort((a, b) => a.Company - b.Company || b.Type - a.Type || a.BankName.localeCompare(b.BankName) || a.Installment - b.Installment)
        return setState({ akodeInstallment: mydata })
      }
    })
  }
  const getCompanies = async () => {
    const getCompaniesApi: GetCompaniesApi = new GetCompaniesApi({})
    getCompaniesApi.getCompanies().then((res: ICompany[]) => {
      if (res) {
        const data: ICompany[] = res
        // data.push({
        //   Name: 'Index (Param Pos)',
        //   Image: '',
        //   IyzipayMerchantKey: '',
        //   Id: 100,
        //   Code: '100'
        // })
        setState({ companies: res })
      }
    })
  }

  const getParamBanks = async () => {
    const data: ISelectOption[] = []
    const getBankListApi: GetBankListApi = new GetBankListApi({})
    getBankListApi.getParamBankList().then((res: IBank[]) => {
      if (res) {
        res.map((ins) => {
          if (
            data.findIndex(dt => {
              return +dt.value === +ins.BankID
            }) === -1
          )
            return data.push({ value: ins.BankID, label: ins.BankName })
          return data
        })
        return setState({ paramBanks: data, })
      }
    })
  }


  const getParatikaBanks = async () => {
    const data: ISelectOption[] = []
    const getBankListApi: GetBankListApi = new GetBankListApi({})
    getBankListApi.getParatikaBankList().then((res: IBank[]) => {
      if (res) {
        res.map((ins) => {
          if (data.findIndex(dt => +dt.value === +ins.BankID) === -1)
            return data.push({ value: ins.BankID, label: ins.BankName })
          return data
        })
        return setState({ paratikaBanks: data })
      }
    })
  }

  const getAkOdeBanks = async () => {
    const data: ISelectOption[] = []
    const getBankListApi: GetBankListApi = new GetBankListApi({})
    getBankListApi.getAkOdeBankList().then((res: IBank[]) => {
      if (res) {
        res.map((ins) => {
          if (data.findIndex(dt => +dt.value === +ins.BankID) === -1)
            return data.push({ value: ins.BankID, label: ins.BankName })
          return data
        })
        return setState({ akodeBanks: data })
      }
    })
  }
  const selectCampaign = async () => {
    const data: ISelectOption[] = []
    const dataCampaign: ISelectOption[] = []
    state.bankInstallmentsData?.PaymentInstallments.map(payment =>
      payment.Installments.map(ins => {
        if (
          data.findIndex(dt => {
            return +dt.value === +ins.BankId
          }) === -1
        )
          data.push({ value: ins.BankId, label: ins.BankName })
        if (ins.PaymentTermsId > 0) {
          if (
            dataCampaign.findIndex(dt => {
              return +dt.value === +ins.PaymentTermsId
            }) === -1
          )
            if (state.companyOption && ins.Company == state.companyOption?.value.toString())
              return dataCampaign.push({ value: ins.PaymentTermsId, label: ins.PaymentTermsName })
            else if (!state.companyOption)
              return dataCampaign.push({ value: ins.PaymentTermsId, label: ins.PaymentTermsName })
        }
      })
    )
    setState({ campaigns: dataCampaign })
  }

  const setBank = async (type: string) => {
    if (type != "4" && type != "5" && type != "6") {
      const data: ISelectOption[] = []
      const dataCampaign: ISelectOption[] = []
      state.bankInstallmentsData?.PaymentInstallments.map(payment =>
        payment.Installments.map(ins => {
          if (
            data.findIndex(dt => {
              return +dt.value === +ins.BankId
            }) === -1
          )
            data.push({ value: ins.BankId, label: ins.BankName })
          if (ins.PaymentTermsId > 0) {
            if (
              dataCampaign.findIndex(dt => {
                return +dt.value === +ins.PaymentTermsId
              }) > -1
            )
              return dataCampaign.push({ value: ins.PaymentTermsId, label: ins.PaymentTermsName })
          }
        })
      )
      setState({ banks: data })
    }
    else if (type == "4")
      setState({ banks: state.paramBanks })
    else if (type == "5")
      setState({ banks: state.paratikaBanks })
    else if (type == "6")
      setState({ banks: state.akodeBanks })
  }

  useEffect(() => {
    filterInstallment()
    selectCampaign()
  }, [state.companyOption, state.typeOption, state.bankOption, state.campaignsOption])

  const filterInstallment = async () => {
    let data: IInstallments[] = []
    if (state.selectedPosType === "4") {
      return setState({
        installment: state.paramInstallment.filter(a => {
          if (state.companyOption && state.companyOption.value !== +a.Company) {
            return false
          }
          if (state.bankOption && a.BankId.toString() !== state.bankOption.value.toString()) {
            return false
          }
          return true
        }),
      })
    }
    if (state.selectedPosType === "5") {
      return setState({
        installment: state.paratikaInstallment.filter(a => {
          if (state.companyOption && state.companyOption.value !== +a.Company) {
            return false
          }
          if (state.bankOption && a.BankId.toString() !== state.bankOption.value.toString()) {
            return false
          }
          return true
        }),
      })
    }
    if (state.selectedPosType === "6") {
      return setState({
        installment: state.akodeInstallment.filter(a => {
          if (state.companyOption && state.companyOption.value !== +a.Company) {
            return false
          }
          if (state.bankOption && a.BankId.toString() !== state.bankOption.value.toString()) {
            return false
          }
          return true
        }),
      })
    }

    if (!state.companyOption && !state.typeOption && !state.bankOption && !state.campaignsOption) {
      state.bankInstallmentsData?.PaymentInstallments.map(payment => {
        payment.Installments.map(ins => {
          return data.push({
            BankId: ins.BankId,
            BankName: ins.BankName,
            Id: ins.Id,
            Installment: ins.Installment,
            InterestRate: ins.InterestRate,
            PaymentTermsId: ins.PaymentTermsId,
            PaymentTermsName: ins.PaymentTermsName,
            Type: ins.Type,
            Company: payment.Company,
            AdditionalInstallment: ins.AdditionalInstallment
          })
        })
      })

      let mydata = (data as any).sort((a, b) => {
        // Önce Company'ye göre sıralama
        const companyComparison = a.Company - b.Company;
        if (companyComparison !== 0) {
          return companyComparison;
        }

        // Sonra Type'a göre sıralama
        const typeComparison = b.Type - a.Type;
        if (typeComparison !== 0) {
          return typeComparison;
        }

        // Ardından BankName'e göre sıralama
        if (a.BankName === "Diğer Bankalar" && b.BankName !== "Diğer Bankalar") {
          return 1; // "Diğer Bankalar" en sonda olsun
        } else if (a.BankName !== "Diğer Bankalar" && b.BankName === "Diğer Bankalar") {
          return -1; // "Diğer Bankalar" en sonda olsun
        } else {
          // "Diğer Bankalar" değilse, alfabetik sıralamaya devam et
          const bankNameComparison = a.BankName.localeCompare(b.BankName);
          if (bankNameComparison !== 0) {
            return bankNameComparison;
          }
        }

        // En son Installment'a göre numerik sıralama
        return a.Installment - b.Installment;
      })
      return setState({ installment: mydata })
    }
    if (state.companyOption) {
      state.bankInstallmentsData?.PaymentInstallments.filter(pay => {
        return state.companyOption?.value === +pay.Company
      }).map(payment =>
        payment.Installments.map(ins => {
          return data.push({
            BankId: ins.BankId,
            BankName: ins.BankName,
            Id: ins.Id,
            Installment: ins.Installment,
            InterestRate: ins.InterestRate,
            PaymentTermsId: ins.PaymentTermsId,
            PaymentTermsName: ins.PaymentTermsName,
            Type: ins.Type,
            Company: payment.Company,
            AdditionalInstallment: ins.AdditionalInstallment

          })
        })
      )
    }
    if (state.typeOption) {
      if (data.length > 0) {
        data = data.filter(ins => {
          return ins.Type === state.typeOption?.value
        })
      } else if (!state.companyOption) {
        state.bankInstallmentsData?.PaymentInstallments.map(payment => {
          payment.Installments.filter(insa => {
            return insa.Type === state.typeOption?.value
          }).map(ins => {
            return data.push({
              BankId: ins.BankId,
              BankName: ins.BankName,
              Id: ins.Id,
              Installment: ins.Installment,
              InterestRate: ins.InterestRate,
              PaymentTermsId: ins.PaymentTermsId,
              PaymentTermsName: ins.PaymentTermsName,
              Type: ins.Type,
              Company: payment.Company,
              AdditionalInstallment: ins.AdditionalInstallment

            })
          })
        })
      }
    }
    if (state.bankOption) {
      if (data.length > 0) {
        data = data.filter(ins => {
          return ins.BankId === state.bankOption?.value
        })
      } else if (!state.companyOption && !state.typeOption) {
        state.bankInstallmentsData?.PaymentInstallments.map(payment => {
          payment.Installments.filter(insa => {
            return insa.BankId === state.bankOption?.value
          }).map(ins => {
            return data.push({
              BankId: ins.BankId,
              BankName: ins.BankName,
              Id: ins.Id,
              Installment: ins.Installment,
              InterestRate: ins.InterestRate,
              PaymentTermsId: ins.PaymentTermsId,
              PaymentTermsName: ins.PaymentTermsName,
              Type: ins.Type,
              Company: payment.Company,
              AdditionalInstallment: ins.AdditionalInstallment
            })
          })
        })
      }
    }
    if (state.campaignsOption) {
      if (data.length > 0) {
        data = data.filter(ins => {
          return ins.PaymentTermsId === state.campaignsOption?.value
        })
      } else if (!state.companyOption && !state.typeOption) {
        state.bankInstallmentsData?.PaymentInstallments.map(payment => {
          payment.Installments.filter(insa => {
            return insa.PaymentTermsId === state.campaignsOption?.value
          }).map(ins => {
            return data.push({
              BankId: ins.BankId,
              BankName: ins.BankName,
              Id: ins.Id,
              Installment: ins.Installment,
              InterestRate: ins.InterestRate,
              PaymentTermsId: ins.PaymentTermsId,
              PaymentTermsName: ins.PaymentTermsName,
              Type: ins.Type,
              Company: payment.Company,
              AdditionalInstallment: ins.AdditionalInstallment
            })
          })
        })
      }
    }

    let mydata = (data as any).sort((a, b) => {
      // Önce Company'ye göre sıralama
      const companyComparison = a.Company - b.Company;
      if (companyComparison !== 0) {
        return companyComparison;
      }

      // Sonra Type'a göre sıralama
      const typeComparison = b.Type - a.Type;
      if (typeComparison !== 0) {
        return typeComparison;
      }

      // Ardından BankName'e göre sıralama
      if (a.BankName === "Diğer Bankalar" && b.BankName !== "Diğer Bankalar") {
        return 1; // "Diğer Bankalar" en sonda olsun
      } else if (a.BankName !== "Diğer Bankalar" && b.BankName === "Diğer Bankalar") {
        return -1; // "Diğer Bankalar" en sonda olsun
      } else {
        // "Diğer Bankalar" değilse, alfabetik sıralamaya devam et
        const bankNameComparison = a.BankName.localeCompare(b.BankName);
        if (bankNameComparison !== 0) {
          return bankNameComparison;
        }
      }

      // En son Installment'a göre numerik sıralama
      return a.Installment - b.Installment;
    })
    setState({ installment: mydata })
  }

  const excelButton = async () => {
    try {
      if (state.installment) {
        const data: any[] = []
        if (state.installment.length > 0) {
          state.installment.map((item, index) => {
            if (state.paramposBool) {
              return data.push({
                Sıra: index + 1,
                'Banka Adı': item.BankName,
                'Taksit': item.Installment,
                'Faiz Oranı': item.InterestRate,
              })
            }
            return data.push({
              Sıra: index + 1,
              'Banka Adı': item.BankName,
              'Şirket':
                (item.Company &&
                  state.companies.find(com => {
                    return +com.Code === +item.Company
                  })?.Name)
              ,
              'Ödeme Tipi': types.find(type => {
                return type.value === item.Type
              })?.label,
              'Taksit': item.Installment,
              'Ek Taksit Seçeneği': item.AdditionalInstallment,
              'Faiz Oranı': item.InterestRate,
              'Kampanya': item.PaymentTermsName,
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSX(data, 'Kredi Kartı Komisyon Oranları')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Banka',
        accessor: 'banka',
      },
      {
        Header: 'Şirket',
        accessor: 'sirket',
      },
      {
        Header: 'Ödeme Tipi',
        accessor: 'tip',
      },
      {
        Header: 'Taksit',
        accessor: 'taksit',
      },
      {
        Header: 'Faiz Oran',
        accessor: 'oran',
      },
      {
        Header: 'Kampanya',
        accessor: 'kampanya',
      },
    ],
    []
  )

  const tabledata = useMemo(() =>
    state.installment.map((installment, index) => {
      const typeLabel = types.find(type => type.value === installment.Type)?.label || "";
      const normalizedBankName = normalizeText(installment.BankName)
      let posLabel = ''
      if (!["4", "5", "6"].includes(String(installment.Type))) {
        const matchedPos = state.posDataList.find((pos) => normalizedBankName.includes(normalizeText(pos.Name)))
        if (matchedPos) {
          posLabel = matchedPos.Name
        }
      }
      const tip = `${typeLabel}${posLabel ? ` (${posLabel})` : ''}`;
      const data = {
        banka: <IPImage
          src={
            (state.creditCardCommissionRates as any).find(bank => bank.Id === installment.BankId)?.Bank
          }
          alt=''
          className=''
          style={{}}
        />,
        sirket:
          installment.Company &&
          state.companies.find(com => {
            return +com.Code.toString() === +installment.Company.toString()
          })?.Name,

        tip: tip,
        taksit: <>{installment.Installment}{installment.AdditionalInstallment && " " + installment.AdditionalInstallment}</>,
        oran: installment.InterestRate + "%",
        kampanya: installment.PaymentTermsName
      }

      return data
    })
    , [state.installment, state.posDataList])

  const selectCompareCompany = (company: ICompany) => {
    setState({ compareCompanyOption: company, compareCampaignOption: undefined })
  }

  const compareCompanies = useMemo(() => state.companies.filter(co => co.Name !== 'Index Group'), [state.companies])

  // Seçenekler arasında tek şirket varsa varsayılan olarak o şirket seçili gelsin
  useEffect(() => {
    if (compareCompanies.length === 1 && !state.compareCompanyOption) selectCompareCompany(compareCompanies[0])
  }, [compareCompanies])

  const selectCompareType = (type: { label: string; value: string }) => {
    setState({ compareTypeOption: type.value, compareCampaignOption: undefined })
  }

  const compareCampaignOptions = useMemo(() => {
    if (!state.compareCompanyOption || state.compareTypeOption === '3') return []
    const companyCode = state.compareCompanyOption.Code
    const seen = new Map<number, string>()
    state.bankInstallmentsData?.PaymentInstallments.filter(pay => +pay.Company === +companyCode).forEach(payment => {
      payment.Installments.filter(ins => ins.Type === state.compareTypeOption && ins.PaymentTermsId > 0).forEach(ins => {
        if (!seen.has(ins.PaymentTermsId)) seen.set(ins.PaymentTermsId, ins.PaymentTermsName)
      })
    })
    return Array.from(seen.entries()).map(([value, label]) => ({ value, label }))
  }, [state.compareCompanyOption, state.compareTypeOption, state.bankInstallmentsData])

  const compareShowTable = !!state.compareCompanyOption && (state.compareTypeOption === '3' || !!state.compareCampaignOption)

  const compareBaseRows = useMemo((): ICompareInstallment[] => {
    if (!state.compareCompanyOption) return []
    const companyCode = state.compareCompanyOption.Code

    const sortByBank = (list: ICompareInstallment[]) =>
      [...list].sort((a, b) => bankNameComparator(a.BankName, b.BankName) || a.Installment - b.Installment)

    if (state.compareTypeOption === '3') {
      const cariRows: ICompareInstallment[] = []
      state.bankInstallmentsData?.PaymentInstallments.filter(pay => +pay.Company === +companyCode).forEach(payment => {
        payment.Installments.filter(ins => ins.Type === '3').forEach(ins => {
          cariRows.push({ ...ins, Company: payment.Company })
        })
      })

      const tagProvider = (list: IInstallments[], label: string): ICompareInstallment[] =>
        sortByBank(list.filter(ins => +ins.Company === +companyCode).map(ins => ({ ...ins, ProviderLabel: label })))

      return [
        ...sortByBank(cariRows),
        ...tagProvider(state.akodeInstallment, 'AkÖde'),
        ...tagProvider(state.paratikaInstallment, 'Paratika'),
        ...tagProvider(state.paramInstallment, 'ParamPos'),
      ]
    }

    if (!state.compareCampaignOption) return []
    const rows: ICompareInstallment[] = []
    state.bankInstallmentsData?.PaymentInstallments.filter(pay => +pay.Company === +companyCode).forEach(payment => {
      payment.Installments
        .filter(ins => ins.Type === state.compareTypeOption && ins.PaymentTermsId === state.compareCampaignOption?.value)
        .forEach(ins => rows.push({ ...ins, Company: payment.Company }))
    })
    return sortByBank(rows)
  }, [state.compareCompanyOption, state.compareTypeOption, state.compareCampaignOption, state.bankInstallmentsData, state.paramInstallment, state.paratikaInstallment, state.akodeInstallment])

  const compareColumns = useMemo((): ICompareColumn[] => {
    const seen = new Map<string, ICompareColumn>()
    compareBaseRows.forEach(r => {
      const key = `${r.BankId}::${r.BankName}::${r.ProviderLabel || ''}`
      if (!seen.has(key)) seen.set(key, { key, bankId: r.BankId, bankName: r.BankName, providerLabel: r.ProviderLabel })
    })
    return Array.from(seen.values())
  }, [compareBaseRows])

  const compareRows = useMemo((): ICompareRow[] => {
    const installments = Array.from(new Set(compareBaseRows.map(r => r.Installment))).sort((a, b) => a - b)
    return installments.map(installment => {
      const cellsByKey = new Map<string, ICompareInstallment>()
      compareBaseRows.filter(r => r.Installment === installment).forEach(r => {
        const key = `${r.BankId}::${r.BankName}::${r.ProviderLabel || ''}`
        if (!cellsByKey.has(key)) cellsByKey.set(key, r)
      })
      const rates = Array.from(cellsByKey.values()).map(r => r.InterestRate)
      const bestRate = rates.length > 0 ? Math.min(...rates) : undefined

      return {
        installment,
        label: installment === 1 ? 'Tek Çekim' : String(installment),
        cells: compareColumns.map(col => {
          const entry = cellsByKey.get(col.key)
          return {
            key: col.key,
            rate: entry?.InterestRate,
            isBest: entry !== undefined && bestRate !== undefined && entry.InterestRate === bestRate,
          }
        }),
      }
    })
  }, [compareBaseRows, compareColumns])

  const columnsWithBestRate = useMemo(() => {
    const set = new Set<string>()
    compareRows.forEach(row => {
      row.cells.forEach(cell => {
        if (cell.isBest) set.add(cell.key)
      })
    })
    return set
  }, [compareRows])

  const visibleCompareColumns = useMemo(() => {
    if (!state.compareOnlyBestColumns) return compareColumns
    return compareColumns.filter(
      col => columnsWithBestRate.has(col.key) || (state.compareAlwaysShowGroup && !col.providerLabel)
    )
  }, [compareColumns, columnsWithBestRate, state.compareOnlyBestColumns, state.compareAlwaysShowGroup])

  const compareProviderGroups = useMemo(() => {
    const labels: string[] = []
    visibleCompareColumns.forEach(col => {
      if (col.providerLabel && !labels.includes(col.providerLabel)) labels.push(col.providerLabel)
    })
    return labels
  }, [visibleCompareColumns])

  const compareColumnRefs = useRef<Map<string, HTMLTableCellElement>>(new Map())
  const compareScrollRef = useRef<HTMLDivElement>(null)

  const flashJumpButton = (key: string) => {
    setState({ compareFlashButton: key })
    setTimeout(() => setState({ compareFlashButton: undefined }), 500)
  }

  const scrollToStart = () => {
    flashJumpButton('indexgrup')
    compareScrollRef.current?.scrollTo({ left: 0, behavior: 'smooth' })
  }

  const scrollToProvider = (providerLabel: string) => {
    flashJumpButton(providerLabel)
    const firstCol = visibleCompareColumns.find(col => col.providerLabel === providerLabel)
    if (!firstCol) return
    const el = compareColumnRefs.current.get(firstCol.key)
    const container = compareScrollRef.current
    if (!el || !container) return
    // scrollIntoView'ın hedefi konteynerin sol kenarına (0) hizalaması, sabit "Taksit"
    // sütununun (position: sticky, left: 0) hedef sütunun üzerine binmesine yol açıyordu.
    // Bu yüzden hedefi, sabit sütun genişliği kadar sağa kaydırarak manuel hesaplıyoruz.
    const containerRect = container.getBoundingClientRect()
    const elRect = el.getBoundingClientRect()
    const targetLeft = container.scrollLeft + (elRect.left - containerRect.left) - STICKY_COLUMN_WIDTH
    container.scrollTo({ left: Math.max(targetLeft, 0), behavior: 'smooth' })
  }

  const compareExcelFileName = () => {
    const typeLabel = (compareTypeTabs.find(ct => ct.value === state.compareTypeOption)?.label || 'Oranlar').replace(/\s+/g, '')
    const companyLabel = (state.compareCompanyOption?.Name || '').replace(/\s+/g, '')
    const dateLabel = new Date().toLocaleDateString('tr-TR')
    return [typeLabel, companyLabel, dateLabel].filter(Boolean).join('-')
  }

  const compareExcelButton = () => {
    try {
      if (compareRows.length === 0) {
        Swal.fire({ icon: 'error', title: 'Excele atılacak veri bulunmamaktadır.', allowOutsideClick: true, backdrop: true })
        return
      }
      // Aynı banka ismi hem normal hem POS sütununda geçiyorsa (örn. "Garanti" ve "Garanti (AkÖde)")
      // parantezli POS bilgisini yalnızca çakışma varsa ekleyip veri kaybını önlüyoruz.
      const nameCounts = new Map<string, number>()
      compareColumns.forEach(col => nameCounts.set(col.bankName, (nameCounts.get(col.bankName) || 0) + 1))

      const data = compareRows.map(row => {
        const rowData: any = { Taksit: row.label }
        row.cells.forEach((cell, idx) => {
          const col = compareColumns[idx]
          const hasCollision = (nameCounts.get(col.bankName) || 0) > 1
          const colName = hasCollision && col.providerLabel ? `${col.bankName} (${col.providerLabel})` : col.bankName
          rowData[colName] = cell.rate !== undefined ? `${cell.rate}%` : '-'
        })
        return rowData
      })
      exportToXLSX(data, compareExcelFileName())
    } catch (err: any) {
      Swal.fire({ icon: 'error', title: err.description, allowOutsideClick: true, backdrop: true })
    }
  }

  return (
    <div className='col-md-12'>
      <div className={financialButtonStyles}>
        <IPButton
          className={`${state.operation === operationType.Payments ? 'active' : ''}`}
          name='company'
          onClick={() => setState({ operation: operationType.Payments })}
          text='Ödemelerim'
          style={{
            color: 'white',
            backgroundColor: 'red',
          }}
        />
        <IPButton
          className={`${state.operation === operationType.Cart ? 'active' : ''}`}
          name='order'
          onClick={() =>
            setState({
              operation: operationType.Cart,
              companyOption: undefined,
              banks: [],
              campaigns: [],
              bankOption: undefined,
              campaignsOption: undefined,
              typeOption: undefined,
            })
          }
          text='Sepet'
        />
        <IPButton
          className={`${state.operation === operationType.Compare ? 'active' : ''}`}
          name='compare'
          onClick={() => setState({ operation: operationType.Compare })}
          text='Tüm Oranları Karşılaştır'
        />
      </div>

      {state.operation === operationType.Payments && (
        <div className='col-md-12'>
          <div className='row' style={{ marginBottom: '10px' }}>
            <div className='col-md-3'>
              <IPSelectBox
                isClearable
                placeholder='Şirket'
                options={state.companies
                  .filter(co => {
                    return co.Name !== 'Index Group'
                  })
                  .map(com => {
                    return { value: com.Code, label: com.Name }
                  })}
                value={state.companyOption ? state.companyOption : null}
                onChangeSingle={(option: ISelectOption) => {
                  if (option) {
                    setState({ companyOption: option })
                    setState({ campaignsOption: undefined })
                  } else
                    setState({
                      companyOption: undefined,
                      campaignsOption: undefined,
                    })
                }}
              />
            </div>
            <div className='col-md-3'>
              <IPSelectBox
                isClearable
                placeholder='Tip'
                options={types.filter(typeOption =>
                  (typeOption.value === "4" && state.paramInstallment.length > 0) || (typeOption.value === "5" && state.paratikaInstallment.length > 0) || (typeOption.value === "6" && state.akodeInstallment.length > 0)
                  ||
                  state.bankInstallmentsData?.PaymentInstallments.some(paymentInstallment =>
                    paymentInstallment.Installments.some(installment =>
                      installment.Type === typeOption.value.toString()
                    )
                  )
                )}
                value={state.typeOption ? state.typeOption : null}
                onChangeSingle={(option: ISelectOption) => {
                  if (option) {
                    setBank(option.value.toString())
                    setState({ typeOption: option, paramposBool: ["4", "5", "6"].includes(option.value.toString()), selectedPosType: option.value.toString() })
                    if (["4", "5", "6"].includes(option.value.toString())) {
                      setState({ bankOption: undefined, campaignsOption: undefined })
                    }
                  }
                  else {
                    setBank("0")
                    setState({ typeOption: undefined, paramposBool: false, selectedPosType: undefined, })
                  }
                }}
              />
            </div>
            <div className='col-md-3'>
              <IPSelectBox
                isClearable
                placeholder='Banka'
                options={state.banks}
                value={state.bankOption ? state.bankOption : null}
                onChangeSingle={(option: ISelectOption) => {
                  if (option) setState({ bankOption: option })
                  else setState({ bankOption: undefined })
                }}
              />
            </div>
            <div className='col-md-3'>
              <IPSelectBox
                isClearable
                placeholder='Kampanya'
                isDisabled={state.paramposBool}
                options={state.campaigns}
                value={state.campaignsOption ? state.campaignsOption : null}
                onChangeSingle={(option: ISelectOption) => {
                  if (option) setState({ campaignsOption: option })
                  else setState({ campaignsOption: undefined })
                }}
              />
            </div>
            {/* <div className='col-md-2'>
              <IPButton
                className='filter'
                name='filter'
                onClick={() => filterInstallment()}
                text='Süz'
                style={{
                  width: "25px"
                }}
              />
            </div> */}
          </div>
        </div>
      )}
      {state.operation === operationType.Cart && (
        <>
          <h5>Iyzico Sepet Oranları</h5>
          <div className='form-group form-fg'>
            <table className='table'>
              <thead className='table-light '>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '25%' }}></th>
                  <th style={{ textAlign: 'center', width: '40%' }}>Taksit Sayısı</th>
                  <th style={{ textAlign: 'center', width: '35%' }}>Oran</th>
                </tr>
              </thead>
              <tbody>
                {state.bankInstallmentsData &&
                  state.bankInstallmentsData.BasketInstallments.length > 0 &&
                  (state.bankInstallmentsData.BasketInstallments as any).map(installment => {
                    return (
                      <tr key={installment.Id}>
                        <td style={{ textAlign: 'center' }}><img src='../images/iyzico_ile_ode_colored_horizontal.png' style={{ width: '40%' }}></img></td>
                        <td style={{ textAlign: 'center' }}>{installment.TaksitSayisi && installment.TaksitSayisi}</td>
                        <td style={{ textAlign: 'center' }}>{installment.Oran && `${installment.Oran}%`}</td>
                      </tr>
                    )
                  })}
              </tbody>
            </table>
          </div>
        </>
      )}
      {state.operation === operationType.Payments && (
        <>

          <div className='row mt-2 mb-2'>
            <div className='col-md-3'>
              <h5>Ödeme Oranları</h5>
            </div>

            <div className='col-md-9 d-flex' style={{ placeContent: 'flex-end' }}>
              <span>Komisyon Oranları Exceli: </span>
              <button
                type='button'
                style={{
                  border: '1px solid #2e7d32',
                  borderRadius: 0,
                  width: '29px',
                  height: '29px',
                  backgroundColor: 'white',
                  margin: '0 10px',
                }}
                onClick={excelButton}
                className='btn text-capitalize background-white-important d-flex align-items-center'
              >
                <i
                  className='fas fa-file-excel'
                  style={{
                    marginLeft: '-6px',
                    fontSize: '18px',
                    color: '#2e7d32',
                  }}
                ></i>
              </button>
            </div>
          </div>

          <div className='form-group form-fg'>
            <Table columns={columns} data={tabledata} currentPage={0} />
          </div>
        </>
      )}

      {state.operation === operationType.Compare && (
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-6'>
              <div className={financialButtonStyles}>
                {compareTypeTabs.map(ct => (
                  <IPButton
                    key={ct.value}
                    className={state.compareTypeOption === ct.value ? 'active' : ''}
                    name='compareType'
                    onClick={() => selectCompareType(ct)}
                    text={ct.label}
                  />
                ))}
              </div>
            </div>
            <div className='col-md-6'>
              <div className={financialButtonStyles} style={{ justifyContent: 'flex-end' }}>
                {compareCompanies.map(co => (
                  <IPButton
                    key={co.Code}
                    className={`${co.Name} ${state.compareCompanyOption?.Code === co.Code ? 'active' : ''}`}
                    name='compareCompany'
                    onClick={() => selectCompareCompany(co)}
                    text={co.Name}
                  />
                ))}
              </div>
            </div>
          </div>

          {state.compareTypeOption !== '3' && (
            <div className='row' style={{ marginBottom: '10px' }}>
              <div className='col-md-3'>
                <IPSelectBox
                  isClearable
                  placeholder='Kampanya'
                  options={compareCampaignOptions}
                  value={state.compareCampaignOption ? state.compareCampaignOption : null}
                  onChangeSingle={(option: ISelectOption) => setState({ compareCampaignOption: option || undefined })}
                />
              </div>
            </div>
          )}

          {compareShowTable ? (
            <>
              <div className='row mt-2'>
                <div className='col-md-12'>
                  <h3 style={{ textAlign: 'center' }}>
                    {compareTypeTabs.find(ct => ct.value === state.compareTypeOption)?.label} Komisyon Oranları
                  </h3>
                </div>
              </div>
              <div className='row mb-2'>
                <div className='col-md-12 d-flex' style={{ placeContent: 'flex-end' }}>
                  <span>Excel: </span>
                  <button
                    type='button'
                    style={{
                      border: '1px solid #2e7d32',
                      borderRadius: 0,
                      width: '29px',
                      height: '29px',
                      backgroundColor: 'white',
                      margin: '0 10px',
                    }}
                    onClick={compareExcelButton}
                    className='btn text-capitalize background-white-important d-flex align-items-center'
                  >
                    <i
                      className='fas fa-file-excel'
                      style={{
                        marginLeft: '-6px',
                        fontSize: '18px',
                        color: '#2e7d32',
                      }}
                    ></i>
                  </button>
                </div>
              </div>
              <div className='d-flex' style={{ gap: '20px', marginBottom: '10px' }}>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='compareOnlyBestCheckbox'
                    checked={state.compareOnlyBestColumns}
                    onChange={e => setState({ compareOnlyBestColumns: e.target.checked })}
                  />
                  <label className='form-check-label' htmlFor='compareOnlyBestCheckbox'>
                    Sadece Avantajlı Oranlar
                  </label>
                </div>
                <div className='form-check'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    id='compareAlwaysShowGroupCheckbox'
                    checked={state.compareAlwaysShowGroup}
                    onChange={e => setState({ compareAlwaysShowGroup: e.target.checked })}
                  />
                  <label className='form-check-label' htmlFor='compareAlwaysShowGroupCheckbox'>
                    Grup Oranlarını Her Zaman Göster
                  </label>
                </div>
              </div>
              {compareProviderGroups.length > 0 && (
                <div className={financialButtonStyles}>
                  <IPButton
                    key='indexgrup'
                    text='IndexGrup'
                    className={state.compareFlashButton === 'indexgrup' ? 'active' : ''}
                    onClick={scrollToStart}
                  />
                  {compareProviderGroups.map(label => (
                    <IPButton
                      key={label}
                      text={label}
                      className={state.compareFlashButton === label ? 'active' : ''}
                      onClick={() => scrollToProvider(label)}
                    />
                  ))}
                </div>
              )}
              <div ref={compareScrollRef} className={`form-group form-fg ${compareTableScrollStyles}`}>
                <table className={`table table-hover ${compareTableStyles}`}>
                  <thead className='table-light'>
                    <tr style={{ textAlign: 'center' }}>
                      <th style={stickyColumnHeaderStyle}>Taksit</th>
                      {visibleCompareColumns.map(col => (
                        <th
                          key={col.key}
                          ref={el => {
                            if (el) compareColumnRefs.current.set(col.key, el)
                            else compareColumnRefs.current.delete(col.key)
                          }}
                          style={{ textAlign: 'center', minWidth: '110px', verticalAlign: 'bottom' }}
                        >
                          <div style={{ minHeight: '20px', marginBottom: '4px', display: 'flex', justifyContent: 'center' }}>
                            {col.providerLabel && providerLogos[col.providerLabel] && (
                              <IPImage
                                src={providerLogos[col.providerLabel]}
                                alt={col.providerLabel}
                                className=''
                                style={{ maxHeight: '20px', maxWidth: '70px' }}
                              />
                            )}
                          </div>
                          <span title={col.bankName}>
                            <IPImage
                              src={(state.creditCardCommissionRates as any).find(bank => bank.Id === col.bankId)?.Bank}
                              alt={col.bankName}
                              className=''
                              style={{ maxWidth: '95px', maxHeight: '55px' }}
                            />
                          </span>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {compareRows.map(row => (
                      <tr key={row.installment}>
                        <td style={stickyColumnCellStyle}>{row.label}</td>
                        {visibleCompareColumns.map(col => {
                          const cell = row.cells.find(c => c.key === col.key)
                          return (
                            <td key={col.key} style={{ textAlign: 'center' }}>
                              {cell?.rate !== undefined ? (
                                <>
                                  {cell.isBest && <i className='icon-star' style={{ color: '#f5a623', marginRight: '4px' }}></i>}
                                  {cell.rate}%
                                </>
                              ) : (
                                '-'
                              )}
                            </td>
                          )
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className='form-group form-fg' style={{ textAlign: 'center', padding: '30px 0', color: '#9b9999' }}>
              {!state.compareCompanyOption ? 'Lütfen şirket seçiniz.' : 'Lütfen kampanya seçiniz.'}
            </div>
          )}
        </div>
      )}

      <div className='form-group form-fg' style={{ marginTop: '50px' }}>
        {state.operation === operationType.Compare && (
          <li>
            <i className='icon-star' style={{ color: '#f5a623', marginRight: '4px' }}></i>
            <b>ikonu, ilgili taksit sayısı için en avantajlı (en düşük) oranı göstermektedir.</b>
          </li>
        )}
        <li>
          Diğer bankalar seçeneği kayıtlı olmayan bankalar için geçerlidir. Bu seçenekle 3D işlem yapılamamaktadır.
        </li>
        <li>YKB 300 TL altındaki işlemlerinize banka tarafından taksit uygulanmamaktadır.</li>
        <li>İş Bankasında 500TL ve altı çekimlerde taksitlendirme yapılmamaktadır.</li>
        <li>Akbank'ta 100TL ve altı çekimlerde taksitlendirme yapılmamaktadır.</li>
        <li>Yukarıdaki tabloda bulunan oranlar KDV dahil toplam maliyetlerinizdir.</li>
      </div>
    </div>
  )
}
export default componentWithContext(CreditCardComissionRates2)





